import SmartPricingRuleModal from './SmartPricingRuleModal';

export default {
  SmartPricingRuleModal,
};
